import React, { useState, useEffect } from "react";
import API from "../../api";
import { ShieldCheck, Globe, HeartHandshake } from "lucide-react";

const AboutUs = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");

  const iconMap = [
    <ShieldCheck size={26} strokeWidth={1.5} />,
    <Globe size={26} strokeWidth={1.5} />,
    <HeartHandshake size={26} strokeWidth={1.5} />,
  ];

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const res = await API.get("/api/about");
        if (res.data && res.data.success) {
          setData(res.data.data);
        }
      } catch (err) {
        console.error("Home About Fetch Error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchAboutData();

    const interval = setInterval(() => {
      const currentLang = localStorage.getItem("lang") || "en";
      if (currentLang !== lang) setLang(currentLang);
    }, 500);

    return () => clearInterval(interval);
  }, [lang]);

  if (loading) return <div className="py-20 bg-white" />;
  if (!data) return null;

  const t = (field) => field?.[lang] || field?.["en"] || "";

  return (
    <section className="bg-white py-12 md:py-12">

      <div className="px-4 mx-auto max-w-[1200px] md:px-6">

        {/* TOP */}
        <div className="text-center mb-12">

          <span className="text-[#B08D57] uppercase tracking-[0.35em] font-semibold text-[11px] mb-4 block font-sans">
            {t(data.subHeading)}
          </span>

          <h2 className="text-[28px] md:text-[34px]  text-[#1A1A1A] mb-5 leading-tight">
            {t(data.mainHeading)}
          </h2>

          <p className="text-[14px] md:text-[16px] leading-relaxed text-[#999999] max-w-[900px] mx-auto">
            {t(data.description)}
          </p>

        </div>

        {/* FEATURES CARDS */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

          {(data.features || []).slice(0, 3).map((item, index) => (
            <div
              key={item._id || index}
              className="group bg-[#F5F0E8] border border-[#eee7dc]  p-7 text-center shadow-sm hover:shadow-xl transition-all duration-500 hover:-translate-y-1"
            >

              {/* ICON */}
              <div className="flex justify-center mb-5">
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white text-[#B08D57] group-hover:bg-[#B08D57] group-hover:text-white transition-all duration-300">
                  {iconMap[index]}
                </div>
              </div>

              {/* TITLE */}
              <h3 className="text-[18px] font-serif text-[#1A1A1A] mb-3">
                {t(item.title)}
              </h3>

              {/* DESC */}
              <p className="text-[14px] md:text-[15px] leading-relaxed text-[#999999]">
                {t(item.desc)}
              </p>

             
            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default AboutUs;